import Axios from "axios";

const apiInstance = Axios.create();

apiInstance.interceptors.response.use(
  response => response,
  err => {
    // No response at all (network failure, timeout, CORS, offline): do not
    // dereference err.response — it would throw a TypeError inside the
    // interceptor and mask the real failure.
    if (!err.response) {
      err.message = "networkError";
      err.isNetworkError = true;
      return Promise.reject(err);
    }
    if (err.response.status === 401) {
      err.isSessionAuth = true;
      return Promise.reject(err);
    }
    if (err.response.status === 403 && err.response.data?.message !== "comment_moderated") {
      err.isSessionAuth = true;
      return Promise.reject(err);
    }
    if (!err.response.data?.message && !err.response.data?.code) {
      return Promise.reject(new Error("internalError"));
    }
    // Instead of creating a new Error with just the message,
    // preserve the full axios error so we can access response data
    return Promise.reject(err);
  }
);

export default apiInstance;
